export const TABS_ID = {
  contacts: 'contacts',
  associations: 'associations',
  comments: 'comments',
  playbooks: 'playbooks'
};